(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.collection-card').forEach(card => {
  const slides = card.querySelectorAll('.collection-card__slide');
  if (slides.length < 2) return;
  let current = 0, timer = null;
  card.addEventListener('mouseenter', () => {
    timer = setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }, 1200);
  });
  card.addEventListener('mouseleave', () => {
    clearInterval(timer);
    slides.forEach(s => s.classList.remove('active'));
    current = 0;
    slides[0].classList.add('active');
  });
});
  } catch(e) { console.error(e); }
})();

})();
